<nav class='navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white'>
    <div class="container-fluid">
      <a class="navbar-brand h6 ml-3" [routerLink]='["/"]'>Billing Portal</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation"
              [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row" [ngClass]='{"show": isExpanded}'>
        <ul class="navbar-nav w-100 nav-tabs justify-content-center mb-3">
  
          <li class="nav-item">
            <a class="nav-link" [routerLinkActive]='["active"]' [routerLink]='["/invoicing"]'>Invoicing</a>
          </li>
          <li class="nav-item" *ngIf = 'this.role == "Admin"'>
            <a class="nav-link" [routerLinkActive]='["active"]' [routerLink]='["/administration"]'>Administration</a>
          </li>
        </ul>
      </div> -->
       <!-- <button  class = "btn btn-info my-4 btn-block"(click) = "logout()">logout</button> -->

       <button  mat-flat-button (click) = "logout()">
       
        <mat-icon  class='' >
                  logout
        </mat-icon>
</button>
<!-- <button mat-button [matMenuTriggerFor]="menu"> <mat-icon  class='' >
  logout
</mat-icon></button> -->
<!-- #enddocregion mat-menu-trigger-for -->
<!-- <mat-menu #menu="matMenu">
  <button mat-menu-item (click) = "logout()">Logout</button>
</mat-menu> -->
    </div>
  </nav>